import axios from 'axios';
import type {
  CompraAINotificationContact,
  WhatsappAccessNumber,
  WhatsappAccessScope,
} from '../types/management';

interface SettingsResponse {
  sucess: boolean;
  data: Array<{
    description: string;
    value: string;
  }>;
}

/*export async function getWhatsAppContacts(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/whatsapp_notification_numbers');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    try {
      return JSON.parse(valueStr);
    } catch {
      return [];
    }
  }

  return [];
}

export async function saveWhatsAppContacts(phoneNumbers: string[]): Promise<void> {
  const value = JSON.stringify(phoneNumbers);
  await axios.put('/settings/users/whatsapp_notification_numbers', {
    value,
  });
}

export async function getEmailRecipients(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/emails_pedidos_sem_faturamento_magento');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    if (valueStr) {
      return valueStr.split(',').map((email) => email.trim()).filter(Boolean);
    }
  }

  return [];
}

export async function saveEmailRecipients(emails: string[]): Promise<void> {
  const value = emails.join(',');
  await axios.put('/settings/users/emails_pedidos_sem_faturamento_magento', {
    value,
  });
}*/

interface WhatsappAccessNumbersResponse {
  success: boolean;
  data: WhatsappAccessNumber[];
  error?: string;
}

export async function getWhatsappAccessNumbers(scope: WhatsappAccessScope): Promise<WhatsappAccessNumber[]> {
  const response = await axios.get<WhatsappAccessNumbersResponse>('/settings/compra-ai/whatsapp-numbers', {
    params: { scope },
  });

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao carregar numeros de WhatsApp');
  }

  return response.data.data || [];
}

export async function updateWhatsappAccessNumberStatus(idWhatsappNumber: string, isActived: boolean): Promise<void> {
  const response = await axios.put<{ success: boolean; error?: string }>(
    `/settings/compra-ai/whatsapp-numbers/${idWhatsappNumber}/status`,
    { is_actived: isActived ? 1 : 0 }
  );

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao atualizar status do WhatsApp');
  }
}

interface CompraAINotificationContactsResponse {
  success: boolean;
  data: CompraAINotificationContact[];
  error?: string;
}

export async function getCompraAINotificationContacts(): Promise<CompraAINotificationContact[]> {
  const response = await axios.get<CompraAINotificationContactsResponse>(
    '/settings/compra-ai/notification-numbers'
  );

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao carregar numeros de notificacao');
  }

  return response.data.data || [];
}

export async function saveCompraAINotificationContacts(
  contacts: CompraAINotificationContact[]
): Promise<CompraAINotificationContact[]> {
  const response = await axios.put<CompraAINotificationContactsResponse>(
    '/settings/compra-ai/notification-numbers',
    { contacts }
  );

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao salvar numeros de notificacao');
  }

  return response.data.data || [];
}

export async function saveEmailRecipients(permissionName: string, emails: string[]): Promise<void> {
  const value = emails.join(',');
  await axios.put(`/settings/users/${permissionName}`, {
    value,
  });
}

export async function triggerUnbilledOrdersReport(): Promise<void> {
  await axios.post('/settings/users/emails_pedidos_sem_faturamento_magento');
}

export async function triggerReport(permissionName: string, email?: string): Promise<void> {
  await axios.post(`/settings/users/${permissionName}`, email ? { email } : undefined);
}


export async function getWhatsAppContacts(): Promise<string[]> {
  const response = await axios.get<SettingsResponse>('/settings/users/whatsapp_notification_numbers');

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    try {
      return JSON.parse(valueStr);
    } catch {
      return [];
    }
  }

  return [];
}

export async function saveWhatsAppContacts(phoneNumbers: string[]): Promise<void> {
  const value = JSON.stringify(phoneNumbers);
  await axios.put('/settings/users/whatsapp_notification_numbers', {
    value,
  });
}

export async function getEmailRecipients(permissionName: string): Promise<string[]> {
  const response = await axios.get<SettingsResponse>(`/settings/users/${permissionName}`);

  if (response.data.sucess && response.data.data.length > 0) {
    const valueStr = response.data.data[0].value;
    if (valueStr) {
      return valueStr.split(',').map((email) => email.trim()).filter(Boolean);
    }
  }

  return [];
}

export {
  getTableSchemaAlertSettings,
  saveTableSchemaAlertContacts,
  triggerTableSchemaCheck,
} from './tableSchemaAlertService';
export type {
  TableSchemaAlertSettings,
  TableSchemaCheckReport,
} from './tableSchemaAlertService';
